module.exports = __webpack_public_path__ + "940f3a2da9aacfe94d8fa27f97257407.pdf";